<template>
  <div>
    <OssUpload v-bind="$_attrs" v-on="$listeners">
      <el-button v-if="!$_attrs.disabled" size="small" type="primary">
        点击上传
      </el-button>
    </OssUpload>
    <preview ref="preview" :url="currUrl" />
  </div>
</template>

<script>
import OssUpload from '../OssUpload'
import Preview from './preview'

export default {
  inheritAttrs: false,
  name: 'OssPictureUpload',
  components: { OssUpload, Preview },
  data() {
    return {
      currUrl: ''
    }
  },
  computed: {
    $_attrs() {
      const { disabled, type } = this.$attrs
      return {
        accept: 'image/jpg, image/jpeg, image/gif, image/png',
        'on-preview': this.preview,
        'on-exceed': this.exceed,
        multiple: true,
        'show-file-list': type === 'avatar' ? false : true,
        ...this.$attrs,
        disabled: disabled === '' ? true : disabled
      }
    }
  },
  methods: {
    preview({ url }) {
      this.currUrl = url
      this.$refs.preview.show()
    },
    exceed() {
      let { limit } = this.$attrs
      if (limit) {
        this.$message({
          message: `最多上传${limit}张`,
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/OssPictureUpload/index.vue